/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle04Icon32Regular = forwardRef('NumberCircle04Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19.231 17.512v-2.465h-2.244v2.465h-3.213l4.624-7.531h-2.516l-4.403 7.242v2.125h5.508V22h2.244v-2.652h1.598v-1.836h-1.598Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3ZM5 16C5 9.925 9.925 5 16 5s11 4.925 11 11-4.925 11-11 11S5 22.075 5 16Z" })));
});
